namespace GeniuzPOS.InventoryReport {
    export class IcReportEomColumns {
        static columnsKey = 'InventoryReport.IcReportEom';
    }
}
